import { GenericContext } from '@app/store/genericContext';
import { ArchivedHeatActions } from './archivedHeatActions';
import { ArchivedHeatState, ARCHIVED_HEAT_INITIAL_STATE } from './archivedHeatState';

export type ArchivedHeatDispatch = (action: ArchivedHeatAction) => void;
export const ARCHIVED_HEAT_INITIAL_DISPATCH = (action: ArchivedHeatAction): void => {
  throw Error('Dispatch not implemented. Action: ' + action.type);
};

export function ArchivedHeatReducer(state: ArchivedHeatState, action: ArchivedHeatAction): ArchivedHeatState {
  const actionType = action.type
  switch (actionType) {
    case ArchivedHeatActions.SET_START_DATE: {
      return { ...state, startDate: action.payload || null };
    }

    case ArchivedHeatActions.SET_END_DATE: {
      return { ...state, endDate: action.payload || null };
    }

    case ArchivedHeatActions.RESET_DATE: {
      return { ...state, startDate: ARCHIVED_HEAT_INITIAL_STATE.startDate, endDate: ARCHIVED_HEAT_INITIAL_STATE.startDate };
    }

    default: {
      throw new Error(`Unidentified action: ${actionType}`);
    }
  }
}

type ArchivedHeatAction =
  | GenericContext<ArchivedHeatActions.SET_START_DATE, string | null>
  | GenericContext<ArchivedHeatActions.SET_END_DATE, string | null>
  | GenericContext<ArchivedHeatActions.RESET_DATE>;
